module.exports = __webpack_public_path__ + "static/media/Elevation Verma Ji.e1f4b3af.jpg";